import React from 'react';
import './InnovationCenter.css';
import {Carousel, Form} from 'antd';
import {GetExhibitionBanner} from "../../api/api";
import {FormattedMessage} from 'react-intl';
import {connect} from "react-redux"
import actions from "../../store/actions"
import VlecImg from "../../component/VlecImg"



let img2 = require("../../static/images/photo-01.png");

 class InnovationCenter extends React.Component {
    state = {
        GetExhibitionBanner: [],
    }

    componentWillMount() {
        
    }
    componentDidMount(){
/*展厅接口*/
GetExhibitionBanner().then((response) => {
    let data = response.DataResult;
    this.setState({
        GetExhibitionBanner: data
    });
});
    }

    render() {
       const centertitle3=this.props.local==='en'?<span>Lenovo Future Center has a total area of 6,500 m<sup>2</sup>,</span>:<span>联想北京未来中心总面积约6500m<sup>2</sup>，其中包含多元智能场景体验和多种行业解决方案展示</span>;
    const f1Title= this.props.local==='en'?<h4 style={{width:"290px"}}>Lenovo Future Center,1<sup>st</sup>floor<br/>— 3,000 m<sup>2</sup></h4>:<h4>联想未来中心1层<br/>——3000 m<sup>2</sup></h4>;
    const f2Title= this.props.local==='en'?<h4 style={{width:"290px"}}>Lenovo Future Center,2<sup>nd</sup>floor<br/>— 2,200 m<sup>2</sup></h4>:<h4>联想未来中心2层<br/>——2200 m<sup>2</sup></h4>;
    const f3Title= this.props.local==='en'?<h4 style={{width:"290px"}}>Lenovo Future Center,3<sup>rd</sup>floor<br/>— 1,300 m<sup>2</sup></h4>:<h4>联想未来中心3层<br/>——1300 m<sup>2</sup></h4>;
        return (<div>
            {/*轮播图片*/}
            <div>
                <Carousel autoplay>
                    {this.state.GetExhibitionBanner.map((item) => {
                        return <div key={item.ID}>
                            {/* <a href={item.URL}> */}
                                <VlecImg src={item.ImagePath} alt=""/>
                            {/* </a> */}

                        </div>
                    })}
                </Carousel>
            </div>
            <div className="indexDiv Innovation_Con">
                <div className="center">
                    <div className="titleH4">
                        <h4>
                      
                            <FormattedMessage
                                id="intl-center-title"
                            />
                            </h4>
                        <p className="smartP">
                        <FormattedMessage
                                id="intl-center-title2"
                            />
                            <br/>
                             <FormattedMessage
                                id="intl-center-title2_1"
                            />
                            <br/>
                             {/* <FormattedMessage
                                id="intl-center-title3"
                            /> */}
                            {centertitle3}
                            <br/>
                               <FormattedMessage
                                id="intl-center-title3_1"
                            />
                        </p>
                       
                    </div>
                </div>
                {/*下面的图片*/}
                <div  className="center centerDiv">
                    <div className="centerBock">
                        <dl>
                            <dt>
                                <img src="images/introduce01.png" alt="" />
                            </dt>
                            <dd>
                              {f1Title}
                                <p><FormattedMessage id="intl-center-f1Title2"/></p>
                            </dd>
                        </dl>
                        <p><FormattedMessage id="intl-center-f1Des"/></p>
                    </div>
                    <div className="centerBock">
                        <dl>
                            <dt>
                            <img src="images/introduce02.png" alt="" />
                            </dt>
                            <dd>
                            {f2Title}
                                <p><FormattedMessage id="intl-center-f2Title2"/></p>
                            </dd>
                        </dl>
                        <p><FormattedMessage id="intl-center-f2Des"/></p>
                    </div>
                    <div className="centerBock">
                        <dl>
                            <dt>
                            <img src="images/introduce03.png" alt="" />
                            </dt>
                            <dd>
                            {f3Title}
                                <p><FormattedMessage id="intl-center-f3Title2"/></p>
                            </dd>
                        </dl>
                        <p><FormattedMessage id="intl-center-f3Des"/></p>
                    </div>
                </div>
                <div className="imgDiv">
                    <ul className="imgBock">
                        <li>
                            <img src="images/data.jpg" alt="" />
                            <div className="imgHover">
                                <h4><FormattedMessage id="intl-center-dataTitle"/></h4>
                                <div className="imgFone">
                                <p>
                                <FormattedMessage id="intl-center-dataDes1"/>
                                </p>
                                    <p>
                                    <FormattedMessage id="intl-center-dataDes2"/>
                                    </p>
                                </div>
                                
                            </div>
                        </li>
                        <li>
                        <img src="images/history.jpg" alt="" />
                            <div className="imgHover">
                                <h4><FormattedMessage id="intl-center-historyTitle"/></h4>
                                <div className="imgFone">
                                <p>
                                <FormattedMessage id="intl-center-historyDes1"/>
                                </p>
                                    <p>
                                    <FormattedMessage id="intl-center-historyDes2"/>
                                    </p>
                                </div>
                                
                            </div>
                        </li>
                        <li>
                        <img src="images/life.jpg" alt="" />
                            <div className="imgHover">
                                <h4> <FormattedMessage id="intl-center-lifeTitle"/></h4>
                                <div className="imgFone">
                                <p>
                                <FormattedMessage id="intl-center-lifeDes1"/>
                                </p>
                                    <p>
                                    <FormattedMessage id="intl-center-lifeDes2"/>
                                    </p>
                                </div>
                                
                            </div>
                        </li>
                        <li>
                        <img src="images/meeting.jpg" alt="" />
                            <div className="imgHover">
                                <h4><FormattedMessage id="intl-center-meetingTitle"/></h4>
                                <div className="imgFone">
                                <p>
                                <FormattedMessage id="intl-center-meetingDes1"/>
                                </p>
                                </div>
                            </div>
                        </li>
                        <li>
                        <img src="images/game.jpg" alt="" />
                            <div className="imgHover">
                                <h4><FormattedMessage id="intl-center-gameTitle"/></h4>
                                <div className="imgFone">
                                <p>
                                <FormattedMessage id="intl-center-gameDes1"/>
                                </p>
                                    <p>
                                    <FormattedMessage id="intl-center-gameDes2"/>
                                    </p>
                                </div>
                                
                            </div>
                        </li>
                        <li>
                        <img src="images/made.jpg" alt="" />
                            <div className="imgHover">
                                <h4><FormattedMessage id="intl-center-madeTitle"/></h4>
                                <div className="imgFone">
                                <p>
                                <FormattedMessage id="intl-center-madeDes1"/>
                                </p>
                                    <p>
                                    <FormattedMessage id="intl-center-madeDes2"/>
                                    </p>
                                    <p>
                                    <FormattedMessage id="intl-center-madeDes3"/>
                                    </p>
                                </div>
                                
                            </div>
                        </li>
                        <li>
                        <img src="images/medical.jpg" alt="" />
                            <div className="imgHover">
                                <h4><FormattedMessage id="intl-center-medicalTitle"/></h4>
                                <div className="imgFone">
                                <p>
                                <FormattedMessage id="intl-center-medicalDes1"/>
                                </p>
                                    <p>
                                    <FormattedMessage id="intl-center-medicalDes2"/>
                                    </p>
                                </div>
                                
                            </div>
                        </li>
                        <li>
                        <img src="images/education.jpg" alt="" />
                            <div className="imgHover">
                                <h4>  <FormattedMessage id="intl-center-educationTitle"/></h4>
                                <div className="imgFone">
                                <p>  <FormattedMessage id="intl-center-educationDes1"/></p>
                                <p>  <FormattedMessage id="intl-center-educationDes2"/></p>
                                <p>  <FormattedMessage id="intl-center-educationDes3"/></p>
                                </div>
                                
                                  
                            </div>
                        </li>
                    </ul>
                </div>
            </div>
        </div>)
    }
};
export default connect(state => ({...state.Language}), actions.Language)(InnovationCenter)


// WEBPACK FOOTER //
// ./src/containers/InnovationCenter/InnovationCenter.js